import Ajv from 'ajv'
import _ from 'lodash'
import addFormat from './format'
import localize from './localize'

const ajv = new Ajv({
  $data: true,
  useDefaults: true,
  allErrors: true,
  jsonPointers: true,
  format: 'full',
  formats: {
    /* eslint-disable no-useless-escape */
    password: /^(?=.*\d)(?=.*[A-Za-z])(?=.*[`\!@#\$%\^&\*\(\)~\-_\=\+\,\.\/<>\?;':"\{\[\]\}])[\da-zA-Z`\!@#\$%\^&\*\(\)~\-_\=\+\,\.\/<>\?;':"\{\[\]\}]{8,20}$/,
    idCard: /^[0-9A-Za-z]{4,50}$/,
    token: /^[0-9]{6}$/,
    phone: /^1[3|4|5|6|7|8|9]\d{9}$/,
    captcha: /^[a-zA-Z0-9]{4}$/,
    countryCode: /^\d+$/
  }
})
const customErrors = ajv.customErrors = []
const valueStore = ajv.valueStore = []

// 添加自定义format
addFormat(ajv)

export function validate (uri, data, path) {
  return new Promise((resolve, reject) => {
    // 加载本地基础校验规则
    const schema = require(`@/schemas/${uri}`)
    const validator = ajv.compile(schema)
    const customErrorsLen = customErrors.length
    customErrors.push([])
    valueStore.push(data)

    // 移除无值结果，保证required校验有效
    Object.keys(data).forEach(key => {
      const value = data[key]

      if (typeof value === 'string') {
        data[key] = value.trim()
      }

      if (!value && (value !== false && value !== 0)) {
        delete data[key]
      }
    })

    let valid = validator(data)
    let errors = validator.errors
    if (!valid) {
      localize(errors, ajv.errors || [], validator.schema, data, customErrors[customErrorsLen], ajv)
    }

    customErrors[customErrorsLen] = null
    valueStore[customErrorsLen] = null

    if (path) {
      const error = _.find(errors, { path })

      if (error) {
        resolve({
          valid,
          errors: [
            error
          ]
        })
      } else {
        resolve({
          valid: true,
          errors: []
        })
      }
    } else {
      resolve({
        valid,
        errors
      })
    }
  })
}

export {
  ajv
}
